import { useSelectedChain } from "@app/examples/ChainSelector"
import { useBaaanggg } from "@hooks/BaaangggHook"
import { ConnectedWallet, useConnectedWallet, useWallet } from "@terra-money/wallet-provider"
import { UserResponse } from "baaanggg"
import { createContext, useContext, useEffect, useState } from "react"

export type AccountContextProps = {
    user?: UserResponse,
    wallet?: ConnectedWallet,
    address?: string
    refreshAccount: () => void
}

export const AccountContext = createContext<AccountContextProps>({
    user: undefined,
    wallet: undefined,
    address: undefined,
    refreshAccount: () => { },
})
export const useAccount = () => useContext(AccountContext)

export const AccountContextProvider = ({ children }: { children: React.ReactNode; }) => {
    const myWallet = useConnectedWallet()
    const baaanggg = useBaaanggg()
    const [user, setUser] = useState<UserResponse>()
    const [address, setAddress] = useState<string>()

    const getAddress = () => myWallet?.terraAddress

    const fetchAccount = async (force = false) => {
        if (user?.walletAddress !== getAddress() || force) {
            let user = undefined;
            try {
                user = await baaanggg.me.get()
            } catch (e) {
                user = undefined;
            }
            setUser(user)
        }
    }

    const main = async () => {
        console.log(myWallet?.terraAddress)
        if (myWallet) {
            setAddress(getAddress())
            await fetchAccount()
        }
    }

    useEffect(() => {
        main()
    }, [myWallet])

    return <AccountContext.Provider value={{
        user: user,
        wallet: myWallet,
        refreshAccount: () => fetchAccount(true),
        address: address
    }}>
        {children}
    </AccountContext.Provider>
}